export class StudentSpeakingScore {
    StudentID: number;
    CalculationDate: Date;
    Score: number;
    CourseCode: string;
    UnitNumber: number;
    ReferenceMinScore: number;
    ReferenceAverageScore: number;
    ReferenceMaxScore: number;
    NormalizedContextualScore: number;
}

export class UnitSparcScore {
    UnitNumber: number;
    StudentScore: number;
    ReferenceAverageScore: number;
}

export class DateSparcScore {
    CalculationDate: Date;
    AvgScore: number;
}